import { useCallback } from 'react';
import clientInfo from 'common/lib/clientInfo';
import { trackProductAnalytics } from 'common/services/product_analytics';

import { PromptFormValuesType } from 'common/components/CopyMagic/CopyMagic.types';
import { CourseOutlineResultType } from 'common/components/CopyMagic/generators/CourseOutline/CourseOutline.types';
import {
  countResultCategories,
  countResultPosts,
  countResultCharacters,
  countResultWords,
} from 'common/components/CopyMagic/generators/CourseOutline/shared/dataHelpers';

type CallbackInput = {
  isSuccess: boolean;
  isModerated: boolean;
  isGeneratedAgain: boolean;
  result: CourseOutlineResultType;
  promptValues: PromptFormValuesType;
};

/*
useTrackPromptResponse trackingCallback
  Because of the invocation location of this tracking callback,
  a race condition can occur with `result` being set in the ResultContext,
  therefore we pass `result` as an arg instead.
*/

const useTrackPromptResponse = () => {
  const trackCallback = useCallback(
    ({ isSuccess, isModerated, isGeneratedAgain, result, promptValues }: CallbackInput) => {
      trackProductAnalytics('Course Outline Generator Results Returned', {
        'Site ID': clientInfo.get('site_id'),
        'Input': promptValues.topic,
        'Is Success': isSuccess,
        'Content Moderated': isModerated,
        'Generated Again': isGeneratedAgain,
        'Content ID': result?.id,
        'Course Outline Model Used': result?.meta?.modelName,
        'Text Length': countResultCharacters(result),
        'Word Count': countResultWords(result),
        'Module Count': countResultCategories(result),
        'Lesson Count': countResultPosts(result),
      });
    },
    [],
  );

  return trackCallback;
};

export default useTrackPromptResponse;
